import { create } from 'zustand';

type Theme = 'dark' | 'light';
const STORAGE_KEY = 'monigo-admin:theme';

function readInitial(): Theme {
  if (typeof window === 'undefined') return 'dark';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return 'dark';
}

interface ThemeState {
  theme: Theme;
  toggle(): void;
  set(theme: Theme): void;
}

export const useTheme = create<ThemeState>((set, get) => ({
  theme: readInitial(),
  toggle() {
    const next: Theme = get().theme === 'dark' ? 'light' : 'dark';
    get().set(next);
  },
  set(theme) {
    if (typeof document !== 'undefined') document.documentElement.dataset.theme = theme;
    if (typeof window !== 'undefined') window.localStorage.setItem(STORAGE_KEY, theme);
    set({ theme });
  },
}));

if (typeof document !== 'undefined') {
  document.documentElement.dataset.theme = readInitial();
}
